import { disableRejectionTracking } from 'hs-promise-rejection-tracking';
import Raven from 'raven-js';

// Copied from hs-promise-rejection-tracking
const isObject = it => {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
function handleUnhandledRejection(e) {
  e.preventDefault();
  if (isObject(e.promise) && e.reason instanceof Promise === false) {
    console.error('Unhandled Promise Rejection', e.reason);
    try {
      const reason = typeof e.reason === 'object' ? JSON.stringify(e.reason) : e.reason;

      // No reason is present, so no point in logging it.
      if (!reason || reason === '{}') return;
      Raven.captureException(new Error('Unhandled Promise rejection'), {
        extra: {
          reason,
          originalReason: e.reason
        }
      });
    } catch (_unused) {
      // If JSON.stringify fails, it means we cant get any error message from the rejection, so theres no point
      // in logging it.
    }
  }
}
export default function enableCustomPromiseRejectionTracking() {
  // Disable default tracking provided by hs-promise-rejection-tracking via head-dlb
  disableRejectionTracking();
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
}